import axios from 'axios';
import { db } from '../firebase/config';
import { 
    collection, 
    doc, 
    getDoc, 
    getDocs, 
    updateDoc, 
    setDoc,
    addDoc,
    query,
    where
} from 'firebase/firestore';

const API_BASE = window.location.hostname === 'localhost'
    ? 'http://localhost:5000/api'
    : 'https://moodprint-main.taila85939.ts.net/api';

const api = axios.create({
    baseURL: API_BASE,
});

// ─── CMS Service API (Refactored for Direct Firebase Access) ─────────────────
export const cmsService = {
    // ── Content / Spotlights ──────────────────────────────────────────────────
    getContent: async () => {
        const docRef = doc(db, 'system', 'content');
        const snap = await getDoc(docRef);
        return { data: snap.exists() ? snap.data() : {} };
    },
    updateContent: async (data) => {
        const docRef = doc(db, 'system', 'content');
        await setDoc(docRef, data, { merge: true });
        return { data: { success: true } };
    },

    // ── Project Registry ─────────────────────────────────────────────────────
    getProjects: async () => {
        const snap = await getDocs(collection(db, 'projects'));
        const projects = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        return { data: { projects } };
    },
    getProjectDetails: async (id) => {
        const docRef = doc(db, 'projects', id);
        const snap = await getDoc(docRef);
        if (snap.exists()) {
            return { data: { project: { id: snap.id, ...snap.data() } } };
        }
        throw new Error('Project not found');
    },
    updateProject: async (id, data) => {
        const docRef = doc(db, 'projects', id);
        // Clean data of undefined values which Firestore hates
        const cleanData = JSON.parse(JSON.stringify(data));
        await updateDoc(docRef, cleanData);
        return { data: { success: true } };
    },


    // ── Relational Credits ────────────────────────────────────────────────────
    updateCredits: async (id, credits) => {
        const docRef = doc(db, 'projects', id);
        await updateDoc(docRef, { credits });
        return { data: { success: true } };
    },

    // ── Ingestion Engine (Still requires server-side scraping) ──────────────
    ingestMetadata: (url, rawText) => api.post('/cms/ingest', { url, rawText }),

    // ── Artist Registry (Cloud Brain) ─────────────────────────────────────────
    createArtist: async (data) => {
        const artistsRef = collection(db, 'artists');
        // Check if artist already exists to avoid duplicates
        const q = query(artistsRef, where('name', '==', data.name));
        const existing = await getDocs(q);
        if (!existing.empty) return { data: { success: true, note: 'Artist exists' } };
        
        await addDoc(artistsRef, data);
        return { data: { success: true } };
    },
    getArtists: async () => {
        const snap = await getDocs(collection(db, 'artists'));
        const artists = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        return { data: { artists } };
    },
    getSystemContributors: async () => {
        // Returns a simple list of names for the autofill system
        const snap = await getDocs(collection(db, 'artists'));
        const contributors = snap.docs.map(d => d.data().name);
        return { data: { contributors } };
    },
};

export default api;

